import { useTranslation } from 'react-i18next'
import './index.scss'
import { COLOR } from '../../data/variables'

type LoadingSpinner = {
  color?: string
}

const LoadingSpinner = ({ color = COLOR.FLOTI_RED }: LoadingSpinner) => {
  const { t } = useTranslation()

  return (
    <svg className="LoadingSpinner" viewBox="0 0 100 100">
      <title>{t('Loading')}</title>
      <circle className="LoadingSpinner__stroke" cx="50%" cy="50%" stroke={color} r={44} fill="transparent" />
    </svg>
  )
}

export default LoadingSpinner
